const MyPurchaseCredit = () => {
    return (
        <div>
            <h1>My Purchase Credit</h1>
        </div>
    );
};

export default MyPurchaseCredit;
